<div class="cart-totals-list">
  @if (cart().subTotal) {
    <sd-cart-totals-list-item [label]="'товары'" [value]="cart().subTotal?.formattedValue"></sd-cart-totals-list-item>
  }

  @if (cart().deliveryCost?.value) {
    <sd-cart-totals-list-item
      [label]="'доставка'"
      [value]="cart().deliveryCost?.formattedValue"
    ></sd-cart-totals-list-item>
  }

  @if (cart().totalDiscounts?.value) {
    <div class="discount">
      <sd-cart-totals-list-item
        [label]="'скидка'"
        [value]="cart().totalDiscounts?.formattedValue"
      ></sd-cart-totals-list-item>
    </div>
  }

  <div class="cart-totals-list-dimensions text-b4-m-300 text-lg-b4-l-300 color-black-warm-800">
    <span>вес {{ cart().weight }} кг</span>
    <span>
      объём {{ cart().volume }} м
      <sup>3</sup>
    </span>
  </div>
</div>
